import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=7edd0946"
import script from "./Chat.vue?vue&type=script&lang=js"
export * from "./Chat.vue?vue&type=script&lang=js"
import style0 from "./Chat.vue?vue&type=style&index=0&id=7edd0946&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7edd0946')) {
      api.createRecord('7edd0946', component.options)
    } else {
      api.reload('7edd0946', component.options)
    }
    module.hot.accept("./Chat.vue?vue&type=template&id=7edd0946", function () {
      api.rerender('7edd0946', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/apps/Chat.vue"
export default component.exports